export const percentileList = [
  { label: "P50", value: "P50" },
  { label: "P65", value: "P65" },
  { label: "P70", value: "P70" },
  { label: "P90", value: "P90" },
]

export const drillDownList = [
  { label: "F3 Category", value: "f3Category" },
  { label: "Velocity Band", value: "velocityBand" },
  { label: "CIF Group", value: "cifGroup" },
]